/**
 * 与App常用交互工具方法
 */

function toast(message) {
    const json = { code: '500', message: message };
    sendMessage(json)
}
export function redirect(code) {
    const json = { code: code };
    sendMessage(json)
}
function redirectUrl(code, url) {
    const json = { code: code, url: url };
    sendMessage(json)
}
function redirectSignalProfile(code, signalId) {
    const json = { code: code, signalId: signalId };
    sendMessage(json)
}
//  APP-H5交互 开始
function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
}

export function sendMessage(data) {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('sendEvent', data, function responseCallback(responseData) {
                // 回调处理
            });
        })
    } else {
        window.vfx_android.webEvent(JSON.stringify(data))
    }
}
